import api from '../api';

/**
 * Consulta o estado de ressincronização do backend.
 *
 * Use após reconexão para decidir o que refetchar, ou sem `since` para obter o
 * cursor inicial + contador de notificações não lidas.
 */
export const fetchRealtimeState = async ({ since = null, pedidoId = null, signal } = {}) => {
  const params = {};

  if (since) params.since = since;
  if (pedidoId) params.pedidoId = pedidoId;

  const { data } = await api.get('/realtime/state', {
    params,
    ...(signal ? { signal } : {}),
  });

  return data;
};

export default fetchRealtimeState;
